import React from 'react';
import ReactDOM from 'react-dom/client';

import "./styles/app.css";
import App from './App';
import { config } from './libs/config';
import { ContextProvider } from './contexts/application';

import { MsalProvider } from '@azure/msal-react';
import { useMsalInstance } from './rbac/msal';
import { RbacClient } from '@e-magic-inc/rbac-client';
import { RbacProvider } from '@e-magic-inc/rbac-client/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

const root = ReactDOM.createRoot(document.getElementById('root'));

// Constructed unconditionally so RbacProvider is always mounted — useRbacClient() is called
// from login.js regardless of mode, and a provider-less hook throws. In local mode nothing
// ever calls through it, but baseUrl is defaulted rather than left undefined so construction
// cannot fail on a deployment that has no RBAC tenant.
const rbacClient = new RbacClient({
  baseUrl: config.rbacBaseUrl || window.location.origin,
  appId: config.rbacAppId || 'twinworx-esb',
});

// MSAL's per-app config is fetched from RBAC asynchronously (see rbac/msal.js), so the
// app's initial render is gated on it resolving — login.js and signout.js both call
// useMsal(), which needs a real MsalProvider ancestor even when SSO isn't configured for
// this app. Resolves almost immediately either way (real config or the inert fallback).
function Root() {
  const msalInstance = useMsalInstance();

  if (!msalInstance) {
    return null;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <RbacProvider client={rbacClient}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ContextProvider>
            <App />
          </ContextProvider>
        </LocalizationProvider>
      </RbacProvider>
    </MsalProvider>
  );
}

root.render(<Root />);


